"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_ace_1 = __importDefault(require("react-ace"));
require("ace-builds/src-noconflict/mode-typescript");
require("ace-builds/src-noconflict/theme-github"); // Light theme
require("ace-builds/src-noconflict/theme-monokai"); // Dark theme
const Editor = ({ value, onChange, readOnly = false, }) => {
    const [theme, setTheme] = (0, react_1.useState)("github"); // Default to light theme
    const [bgColor, setBgColor] = (0, react_1.useState)("white"); // Default to light theme
    (0, react_1.useEffect)(() => {
        // Check the user's preference
        const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)");
        // Set the theme based on the preference
        setTheme(prefersDarkMode.matches ? "monokai" : "github");
        setBgColor(prefersDarkMode.matches ? "#222222" : "white");
        // Add an event listener to update the theme if the preference changes
        const handleChange = (e) => {
            setTheme(e.matches ? "monokai" : "github");
            setBgColor(e.matches ? "#222222" : "white");
        };
        prefersDarkMode.addEventListener("change", handleChange);
        // Clean up the event listener on unmount
        return () => {
            prefersDarkMode.removeEventListener("change", handleChange);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_ace_1.default, { mode: "typescript", theme: theme, name: "editor", value: value, onChange: readOnly ? undefined : onChange, fontSize: 18, width: "100%", height: "100%", readOnly: readOnly, setOptions: {
            enableBasicAutocompletion: !readOnly,
            enableLiveAutocompletion: !readOnly,
            enableSnippets: !readOnly,
            showLineNumbers: true,
            tabSize: 2,
        }, style: {
            flex: "1 0 auto",
            width: "auto",
            height: "auto",
            backgroundColor: bgColor,
        } }));
};
exports.Editor = Editor;
